import React from 'react'
import * as joda from '@js-joda/core'
import { Conversation } from 'types/messages'
import { zeroInstantString } from 'prelude'

export type UserWebSocket = {
  id:string
  firstname:string
  lastname:string
  profile_photo:string
}

export type Like<a> = {
  user:UserWebSocket
  occurred:a
  // is_new:boolean
  matches_preferences:boolean
}

export type Match<a> = {
  user:UserWebSocket
  occurred:a
  // is_new:boolean
}

export type SeenState<a> = {
  likes:a
  matches:a
  // conversations:joda.Instant
}

export type Interactions = {
  likes:Promise<Like<joda.Instant>[]>
  matches:Promise<Match<joda.Instant>[]>
  conversations:Promise<Conversation[]>
  unread:Promise<{ [_:string]:number }>
  seen:Promise<SeenState<joda.Instant>>
  setSeen:(_:SeenState<string>) => void
}

export const mapSeen = (x:SeenState<string>) : SeenState<joda.Instant> => ({
  'likes':joda.Instant.parse(x.likes ?? zeroInstantString),
  'matches':joda.Instant.parse(x.matches ?? zeroInstantString),
})

export const ContextInteractions = React.createContext<Interactions | undefined>(undefined)

export const useInteractions = () => {
  const context = React.useContext(ContextInteractions)
  if(!context)
  {
    throw new Error('useInteractions - no provider')
  }
  return context
}

export default useInteractions
